import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: row;
`;

export const WrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Action = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: #f5f5f5;
  }
`;

export const IconPaper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

export const BoxMap = styled.div`
  width: 73vw;
  height: 84.2vh;
  position: relative;
  margin: 0 15px;

  @media (max-width: 425px) {
    margin-bottom: 30px;
  }
`;

